// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pgb[data-v-13fa38d1]{display:flex;flex-wrap:wrap}", ""]);
// Exports
module.exports = exports;
